import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function QuestionMark({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M12.5118 13.75H10.9333C10.9333 12.3438 11.6108 11.6538 12.2667 11.125C12.328 11.0756 12.3877 11.0297 12.4452 10.9855C12.8211 10.6965 13.101 10.4813 13.101 9.84535C13.101 9.11218 12.7204 8.71555 12.0645 8.71555C11.2688 8.71555 10.9441 9.3125 10.9333 10.25H9.33333C9.36559 8.65144 10.3011 7.33333 12.0538 7.33333C13.6989 7.33333 14.6667 8.42708 14.6667 9.84535C14.6667 11.0353 14.1075 11.516 13.6452 11.9127C12.8387 12.5978 12.5118 12.8966 12.5118 13.75Z"
        fill={iconColor}
      />
      <Path
        d="M12.5269 16.6667H10.9333V14.9239H12.5269V16.6667Z"
        fill={iconColor}
      />
      <Path
        d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM5.33333 12C5.33333 8.3181 8.3181 5.33333 12 5.33333C15.6819 5.33333 18.6667 8.3181 18.6667 12C18.6667 15.6819 15.6819 18.6667 12 18.6667C8.3181 18.6667 5.33333 15.6819 5.33333 12Z"
        fill={iconColor}
      />
    </Svg>
  );
}
